<div class="row gx-0 h-100">

	<!-- Editor panel(s) -->
	<div
		*ngFor="let panelIdentifier of codeEditorPanelIdentifiers"
		class="{{ panelIdentifier }}"
		[ngClass]="{
			'd-none': panelIdentifier === codeEditorPanelIdentifierEnum.SECONDARY && !codeEditorConfig[codeEditorPanelIdentifierEnum.SECONDARY],
			'split-left-right': codeEditorConfig[codeEditorPanelIdentifierEnum.SECONDARY]?.splitView?.orientation === splitViewOrientationEnum.LEFT_RIGHT,
			'col-12 split-top-bottom': codeEditorConfig[codeEditorPanelIdentifierEnum.SECONDARY]?.splitView?.orientation === splitViewOrientationEnum.TOP_BOTTOM,
			'col': codeEditorConfig[codeEditorPanelIdentifierEnum.SECONDARY]?.splitView?.orientation !== splitViewOrientationEnum.TOP_BOTTOM
		}"
	>
		<!-- Editor panel content -->
		<ng-container
			[ngTemplateOutlet]="codeEditorPanel"
			[ngTemplateOutletContext]="{ mapItem: codeEditorPanelMap.get(panelIdentifier) }"
		></ng-container>
	</div>
</div>

<!-- TEMPLATES ############################################################# -->

<!-- Editor panel content -->
<ng-template
	#codeEditorPanel
	let-mapItem="mapItem"
>
	<div class="d-flex flex-column h-100">

		<!-- Editor header -->
		<div
			*ngIf="mapItem.config?.header?.showHeader"
			class="editor-header row gx-0"
		>

			<!-- Gutter -->
			<div
				#gutterExtension
				id="{{ mapItem.config?.identifier + gutterExtensionIdSuffix }}"
				class="ace-editor-gutter-extension h-100"
			></div>

			<!-- Content -->
			<div
				class="editor-header-content col row gx-0 align-items-center fs-xl"
				[ngClass]="{
					'justify-content-end': !mapItem.config?.header.titleI18nPath,
					'justify-content-between': mapItem.config?.header.titleI18nPath
				}"
			>
				<!-- Title -->
				<div
					*ngIf="mapItem.config?.header.titleI18nPath"
					class="editor-title col-auto"
				>
					{{ getI18nString( false, mapItem.config?.header.titleI18nPath ) }}
				</div>

				<!-- Close button -->
				<i
					*ngIf="mapItem.config?.header.renderEditorCloseButton"
					class="close-editor col-auto ft-x"
					(click)="close()"
				></i>
			</div>
		</div>

		<!-- Ace editor -->
		<div
			#editor
			class="app-ace-editor"
			appDomTreeChanged
			[watchAttributes]="true"
			[watchAttributeFilter]="[ 'style' ]"
			[watchChildList]="false"
			[watchSubtree]="false"
			[watchSpecificChildByQuerySelector]="'.' + aceGutterClassName"
			(domChangeEmitter)="adjustGutterExtensionWidth($event, mapItem.config?.identifier)"
		></div>
	</div>
</ng-template>
